const React = require('react');
const OneLineTextField = require('./components/commonControls.jsx.js').OneLineTextField;
const NumericTextField = require('./components/commonControls.jsx.js').NumericTextField;

const AdminAjaxFunctions = require('./adminAjaxFunctions');
import Toastr from 'toastr';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export class FormModal extends React.Component{
   constructor(props) {
      super(props);
   }

   confirm(){
      this.props.confirmFunction();
      this.props.closeFunction();
   }

   render(){
      return(
         <Dialog
            open={this.props.show}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
            <DialogContent>
               <DialogContentText>
                  {this.props.formHeader}
               </DialogContentText>
               {this.props.inputs.map((input) => input)}
            </DialogContent>
            <DialogActions>
               <Button onClick={() => this.props.closeFunction()}>
                  Cancel
               </Button>
               <Button variant="contained" color="primary" onClick={() => this.confirm()}>
                  {this.props.confirmText}
               </Button>
            </DialogActions>
         </Dialog>
      )
   }
}

export class SetHeadlines extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         headlines: [],
         updatingId: 0,
         newText: '',
         newSource: '',
         newLink: '',
         newIsPublic: false,
         newIdx: 0,
         showModal: false,
         modalSubmitFunction: () => {},
         modalHeaderText: '',
         modalSubmitText: '',
      }
   }

   async addHeadline(){
      if(this.state.newText.trim().length === 0) return;

      let newHeadline = {
         text: this.state.newText.trim(),
         source: this.state.newSource.trim(),
         link: this.state.newLink.trim(),
         isPublic: this.state.newIsPublic,
         idx: this.state.newIdx,
      };

      try {
         await AdminAjaxFunctions.createHeadline(newHeadline);

         this.getHeadlines();

         this.setState({
            newText: '',
            newSource: '',
            newLink: '',
            newIsPublic: false,
            newIdx: 0,
         });
      }
      catch(e){
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(e);
      }
      this.setState({showModal: false});
   }

   componentDidMount(){
      this.getHeadlines();
   }

   startUpdateHeadline(headline){
      this.setState({
         updatingId: headline.idHeadline,
         newText: headline.text,
         newSource: headline.source,
         newLink: headline.link,
         newIsPublic: headline.isPublic,
         newIdx: headline.idx,
         showModal: true,
         modalSubmitFunction: () => this.updateHeadline(),
         modalHeaderText: 'Update Announcement',
         modalSubmitText: 'Update',

      })
   }

   async updateHeadline(){
      if(this.state.newText.trim().length === 0) return;

      let updatedHeadline = {
         idHeadline: this.state.updatingId,
         text: this.state.newText.trim(),
         source: this.state.newSource.trim(),
         link: this.state.newLink.trim(),
         isPublic: this.state.newIsPublic,
         idx: this.state.newIdx,
      };

      try {
         await AdminAjaxFunctions.updateHeadline(updatedHeadline);

         this.getHeadlines();

         this.setState({
            updatingId: 0,
            newText: '',
            newSource: '',
            newLink: '',
            newIsPublic: false,
            newIdx: 0,
         });
      }
      catch(e){
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(e);
      }
      this.setState({showModal: false});
   }

   getHeadlines(){
      AdminAjaxFunctions.getCurHeadlines().then(data => {
         this.setState({headlines: data.headlines});
      })
   }

   async removeHeadline(idHeadline){
      try {
         await AdminAjaxFunctions.deleteHeadline(idHeadline);
         this.getHeadlines();
      }
      catch(e){
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error(e);
      }
   }

   render() {
      let modalInputs = [];
      modalInputs.push(
         <OneLineTextField
         id='newHeadlineText'
         className='form__input'
         placeholder={'Announcement Text'}
         data={this.state.newText}
         onChange={ (event) => this.setState({newText: event.target.value}) }
         maxLength="800"
         label='Announcement Text'
         />
      );
      modalInputs.push(
         <OneLineTextField
            id='newHeadlineSource'
            className='form__input'
            placeholder={'Source (optional)'}
            data={this.state.newSource}
            onChange={ (event) => this.setState({newSource: event.target.value}) }
            maxLength="800"
            label='Source (optional)'
         />
      );
      modalInputs.push(
         <OneLineTextField
            id='newHeadlineLink'
            className='form__input'
            placeholder={'URL (optional)'}
            data={this.state.newLink}
            onChange={ (event) => this.setState({newLink: event.target.value}) }
            maxLength="800"
            label='URL (optional)'
         />
      );
      modalInputs.push(
         <NumericTextField
            idInput="newHeadlineIdx"
            label="Index"
            data={this.state.newIdx}
            onChange={(event) => this.setState({newIdx: event.target.value})}
         />
      );
      modalInputs.push(
         <FormControlLabel
            control={
               <Checkbox
                  checked={this.state.newIsPublic}
                  onChange={() => this.setState({newIsPublic: !this.state.newIsPublic})}
                  value="Public"
                  color="primary"
               />
            }
            label="Announcement Is Public"
         />
      );

      return (
         <div className="container">
            <Table>
               <TableHead>
                  <TableRow>
                     <TableCell>
                        Text
                     </TableCell>
                     <TableCell>
                        Source
                     </TableCell>
                     <TableCell>
                        Link
                     </TableCell>
                     <TableCell>
                        Index
                     </TableCell>
                     <TableCell>
                        Is Public
                     </TableCell>
                     <TableCell>
                     </TableCell>
                  </TableRow>
               </TableHead>
               <TableBody>
                  {this.state.headlines.map((headline) => (
                     <TableRow key={headline.idHeadline + headline.text}>
                        <TableCell>
                           {headline.text}
                        </TableCell>
                        <TableCell>
                           {headline.source}
                        </TableCell>
                        <TableCell>
                           {headline.link}
                        </TableCell>
                        <TableCell>
                           {headline.idx}
                        </TableCell>
                        <TableCell>
                           {headline.isPublic}
                        </TableCell>
                        <TableCell>
                           <IconButton
                              onClick={() => this.startUpdateHeadline(headline)}
                              aria-label="Delete"
                           >
                              <FontAwesomeIcon  icon={['far', 'edit']} size={'sm'} />
                           </IconButton>
                           <IconButton
                              onClick={() => this.removeHeadline(headline.idHeadline)}
                              aria-label="Delete"
                           >
                              <FontAwesomeIcon  icon={['far', 'times']} size={'sm'} />
                           </IconButton>
                        </TableCell>
                     </TableRow>
                  ))}
               </TableBody>
            </Table>
            <FormModal
               show={this.state.showModal}
               closeFunction={() => this.setState({showModal: false})}
               confirmFunction={() => this.state.modalSubmitFunction()}
               formHeader={this.state.modalHeaderText}
               confirmText={this.state.modalSubmitText}
               inputs={modalInputs}
            />
            <Button
               variant="contained"
               color="primary"
               onClick={() => this.setState({
                  showModal: true,
                  modalSubmitFunction: () => this.addHeadline(),
                  modalHeaderText: 'Add New Announcement',
                  modalSubmitText: 'Add',
               })}
            >
               New
            </Button>
         </div>

      );
   }
}